<template>
  <div class="page-content">
<!--    <el-button type="primary" plain @click="addInfo">新增</el-button>-->
<!--    <el-button type="primary" plain @click="resetAudit">撤销审核</el-button>-->
<!--    <el-button type="primary" plain @click="audit">重新审核</el-button>-->
    <page-template
      ref="mallgoodsTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
    <el-dialog title='商品信息' :visible.sync="addShow" @close="closeDialog" width="800px" center :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-col :span="24">
          <el-form-item label='条码' prop="barCode">
            <el-input v-model="form.barCode" @change="selectGoodsInfo" :disabled="this.dialogTitle === 'edit'"></el-input>
            <el-button plain type="primary" @click="checkGoods" v-if="this.dialogTitle === 'add'">选择商品</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='商品名称' prop="name">
            <el-input v-model="form.name" :disabled="this.dialogTitle === 'edit'"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label='价格形式' prop="priceType">
            <el-radio-group v-model="form.priceType">
              <el-radio
                v-for="(item,index) in typeList"
                :key="index"
                :label="item.id"
              >{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='价格' prop="price">
            <div v-if="form.priceType == 1">
              <el-input v-model="form.price"></el-input>
            </div>
            <div v-if="form.priceType == 2">
              <el-input v-model="form.price"></el-input>-
              <el-input v-model="form.price2"></el-input>
            </div>
            <div v-if="form.priceType == 3">
              <span>原价</span><el-input v-model="form.price"></el-input>
              <span>折扣价</span><el-input v-model="form.price2"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="coverImg" label="" label-width="0">
            <div style="display: flex">
              <div style="width: 80px;text-align: right;padding-right:9px;">
                <span style="color:red">*</span>
                <span style="">商品图片</span>
              </div>
              <div class="file-upload">
                <div class="img-item" v-if="form.goodsImgUrl">
                  <div class="image-box" :style="{backgroundImage:'url('+form.goodsImgUrl+')'}" @click="previewImg"></div>
                  <i v-if="this.dialogTitle === 'add'" class="el-icon-error icon-delete" @click="fileDelete"></i>
                </div>
                <div v-else>
                  <i class="el-icon-plus" @click="changeUpload" ></i>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='备注' prop="remarks">
            <el-input v-model="form.remarks"></el-input>
          </el-form-item>
        </el-col>
        <div class="dialog-footer">
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1000px" height="800" :close-on-click-modal="false">
      <table-template
        v-if="listShow"
        ref="goodList"
        :tableOptions="goodsOptions"
        @rowClick="rowClick"
      ></table-template>
    </el-dialog>
    <el-dialog title="图片预览" :visible.sync="dialogVisible">
      <div style=";text-align: center">
        <img :src="form.goodsImgUrl" alt="" style="width: 60%">
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import goodList from '@/components/business/goodList';
  import api from '@/config/api';

  export default {
  components: {
    pageTemplate,goodList,tableTemplate
  },
  data() {
    return {
      dialogVisible:false,
      otherParam: {},
      listShow:false,
      dialogTitle:'',
      addShow:false,
      form:{
        url:'pages/details/details',//商品详情页的小程序路径
        coverImg:'',
        coverImgUrl:'',
        goodsImgUrl:'',
        barCode:'',
        name:'',
        priceType:1,
        price:'',//原价
        price2:'',//右区间价 || 折扣价
        remarks:'',
        // thirdPartyTag:1,//1、2：表示是为 api 添加商品，否则是直播控制台添加的商品
        // thirdPartyAppid:'',//当商品为第三方小程序的商品则为对应第三方小程序的appid，自身小程序商品则为
        relateType:this.$utils.getSysUser().storeId?20:10,//10 商户 20门店
      },
      rules:{
        barCode:[{required:true,message:'请输入商品条码',trigger:'change'}],
        name:[{required:true,pattern: "^.{3,14}$", message: '请输入正确名称', trigger: 'blur'}],
        priceType:[{required:true,message:'请选择',trigger:'change'}],
        price:[{required:true,message:'请输入商品价格',trigger:'change'}],
        price2:[{required:true,message:'',trigger:'change'}],
        coverImg:[{required:true,message:'请上传图片',trigger:'change'}],
      },
      typeList:[
        {id:1,label:'一口价'},
        {id:2,label:'价格区'},
        {id:3,label:'折扣价'},
      ],
      // 搜索条件
      searchOptions: {
        simple: [
          {label: '商品状态', prop: 'status',clearable:true, type: 'select', placeholder: "请选择",data:[{name:'未审核',id:'0'},{name:'审核中',id:"1"},{name:'审核通过',id:"2"},{name:'审核驳回',id:"3"}]}
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.editInfo,
          // filter:()=>{
            // console.log(this.$refs['mallgoodsTemplate'].$refs.searchFormTemp.formModel.status)
            // if(this.$refs['mallgoodsTemplate'].$refs.searchFormTemp.formModel.status ==='1'){
            //   return false
            // }
            // return false
          // }
        },
        {
          label: '新增',
          type: this.$utils.buttonType.tableOperate,
          code: 'insert',
          callback: this.addInfo,
        },
        {
          label: '撤销审核',
          type: this.$utils.buttonType.tableOperate,
          code: 'liveGoodsResetAudit',
          callback: this.resetAudit,
        },
        {
          label: '重新审核',
          type: this.$utils.buttonType.tableOperate,
          code: 'liveGoodsAudit',
          callback: this.audit,
        },
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          callback: this.deleteInfo
          // filter:()=>{
          //   return false
          // }
        },
      ],
      // 表格信息配置
      tableOptions: {
        // selectEnable:true,//开启多选禁用
        // showSelect: true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '商品名称',
            prop: 'name',
            align: 'center',
            width: '100',
          },
          {
            label: '价格',
            prop: 'price',
            align: 'center',
            width: '150',
            deal: this.newPrice,
          },
          // {label: '商品图片', prop: 'coverImgUrl', width: '60', align: 'center', type: 'image'},
          // {
          //   label: '创建时间',
          //   prop: 'createDttm',
          //   align: 'center',
          //   width: '120',
          // },
        ],
        layout:'sizes, prev, pager, next',
        pageList:[10, 20, 30, 40,100],
        liveSet:true,//直播间
        param:{
          offset:0,
          limit:10,
          status:2
        },
        // url:api.mall.mallLiveGoodsList
      },
      // 选择的商品列表
      goodsOptions:{
        // showSelect:true,
        oneClick:true,
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '150',
            align: 'center'
          },
          {
            label: "品名",
            prop: "goodsName",
            width: "150",
            align: "center"
          },
          {
            label: "自编码",
            prop: "artNo",
            width: "100",
            align: "center"
          },
          {
            label: "规格",
            prop: "specs",
            width: "70",
            align: "center"
          },
          {
            label: "单位",
            prop: "unitName",
            width: "70",
            align: "center"
          },
          {
            prop: "mallRetailPrice",
            label: "商城零售价",
            align: "center",
            width: "130",
          },
          {
            prop: "mallVipPrice",
            label: "商城会员价",
            align: "center",
            width: "130",
          },
          {
            prop: "mallPlusVipPrice",
            label: "商城Plus会员价",
            align: "center",
            width: "130",
          },
          {
            prop:'mallLowestPrice',
            label: '商城最低价',
            align: 'center',
            width:'130'
          }
        ],
        url: api.mall.asGoodsMall
      },
    };
  },
  created() {
    this.searchOptions.simple.filter(v=>v.prop =='status')[0].defaultValue = "2"
  },
  mounted() {
    this.tableOptions.url = api.mall.mallLiveGoodsList
    this.$refs.mallgoodsTemplate.operationSuccess()
  },
  methods: {
    // 撤回审核
    resetAudit(row){
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.mall.mallLiveGoodsDetail,{goodsId:row.goodsId}).then(res=>{
        if(res.code == 200){
          if(res.data && res.data.auditId){
            this.$axios.fetchPost(api.mall.resetAudit,{goodsId:row.goodsId,auditId:res.data.auditId}).then(res=>{
                if(res.code == 200){
                  if(res.data){
                    this.$refs.mallgoodsTemplate.operationSuccess();
                    this.$notify({
                      type: "success",
                      title: '撤销审核操作',
                      message: '成功',
                      showClose: false,
                    });
                    // this.$message.success('撤销审核成功')
                  }
                }else{
                  this.$message.error(res.errorMsg)
                }
              }).finally(()=>{})
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      }).finally(()=>{
        loading.close()
      })
      //
    },
    // 重新审核
    audit(row){
      const loading = this.$loading({
        lock: true,
        text: '提交中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)',
      });
      this.$axios.fetchPost(api.mall.liveGoodsAudit,{goodsId:row.goodsId}).then(res=>{
        if(res.code == 200){
          if(res.data){
            this.$refs.mallgoodsTemplate.operationSuccess()
            this.$notify({
              type: "success",
              title: '审核操作',
              message: '成功',
              showClose: false,
            });
            // this.$message.success('审核成功')
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      }).finally(()=>{
        loading.close()
      })
    },
    // 判断文件类型
    isExcellType(ext) {
      return ['png','jpg','jpeg','gif'].indexOf(ext.toLowerCase()) !== -1;
    },
    // 上传图片
    changeUpload() {
      this.$utils.uploadFile((file) => {
        let formData = new FormData();
        formData.append('multipartFile', file);
        let index= file.name.lastIndexOf(".");
        let ext = file.name.substr(index+1);
        if(!this.isExcellType(ext)){
          this.$message.warning('PNG,JPEG,JPG,GIF格式!')
        }
        else if(file.size > 1024 * 1024 * 10){
          this.$message.warning('上传文件大小不能超过 10MB!')
        }else{
          this.$axios.fetchPostInUpload('/api/eros/mall/mallLiveRoom/media/upload?fileType=image&merchantId='+this.$utils.getSysUser().merchantId,formData).then((res)=>{
            if(res.code == 200){
              if(res.data){
                  this.form.coverImg = res.data.mediaId
                  this.form.goodsImgUrl = res.data.url
                this.$notify({
                  type: "success",
                  title: '上传操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message.success('上传成功')
              }
            }else{
              this.$message.error(res.errorMsg)
            }
          })
        }
      })
    },
    // 删除图片
    fileDelete() {
        this.form.coverImg = ''
        this.form.goodsImgUrl = ''
    },
    // 预览图片
    previewImg(){
      this.imageUrl = ''
      this.imageUrl = this.form.goodsImgUrl
      this.dialogVisible = true;
    },

    // table 商品价格
    newPrice(row){
      if(row.priceType ==1){
        return `<span class="" >${row.price}</span>`;
      }else if(row.priceType == 2){
        return `<span class="" >${row.price}~${row.price2}</span>`;
      }else{
        return `<span class="" >原价：${row.price}；折扣价：${row.price2}</span>`;
      }
    },
    //通过货号获取商品信息
    selectGoodsInfo(){
      if (this.form.barCode) {
        this.$axios.fetchPost(api.mall.asGoodsMall+'/list', {barCode:this.form.barCode}).then(data => {
          if (data.code === 200) {
            if (data.data.length>0) {
              this.form.barCode = data.data[0].barCode
              this.form.name = data.data[0].goodsName
              this.form.price = data.data[0].mallRetailPrice
            }else{
              this.$message({message: '无对应商品！', type: 'warning'});
              this.form.barCode = ''
              this.form.name = ''
              this.form.price = ''
              this.form.price2 = ''
              this.form.priceType = 1
              this.form.url='pages/details/details'//商品详情页的小程序路径
            }
          } else {
            this.$message({message: data.errorMsg || '请求失败！', type: 'error'});
          }
        });
      }
    },
    // 点击选择商品
    checkGoods() {
      this.listShow = true;
    },
    //选择某行数据
    rowClick(row) {
      this.form={
        coverImg:'',
        coverImgUrl:'',
        goodsImgUrl:'',
        barCode:'',
        name:'',
        priceType:1,
        price:'',//原价
        price2:'',//右区间价 || 折扣价
        remarks:'',
        url:'pages/details/details'//商品详情页的小程序路径
      }
      this.listShow = false;
      this.form.barCode = row.barCode
      this.form.name = row.goodsName
      this.form.price = row.mallRetailPrice
      this.form.goodsId = row.goodsId
    },
    // 创建
    addInfo(){
      this.addShow = true
      this.dialogTitle = 'add'
    },
    // 获取审核状态
    getAuditStatus(row){

    },
    // 编辑
    editInfo(row){
      let arr = []
      arr.push(row)
      this.$axios.fetchPost(api.mall.auditStatus,{goodsList:arr}).then(res=>{//获取审核状态
        if(res.code == 200){
          if(res.data){
            if(res.data.auditStatus === 1){
              this.$message.warning('审核中不允许修改')
            }else{
              this.addShow = true
              this.dialogTitle = 'edit'
              const loading = this.$loading({
                lock: true,
                text: '加载中，请稍候...',
                background: 'rgba(225, 225, 225, 0.8)',
              });
              this.$axios.fetchPost('/api/eros/mall/mallLiveGoods/goods',{goodsId:row.goodsId}).then(res=>{//获取详情
                if(res.code === 200){
                  if(res.data){
                    this.form = res.data
                  }else{
                    this.$message.error( '获取详情失败')
                  }
                }else{
                  this.$message.error( res.errorMsg||'加载失败')
                }
              }).finally(()=>{
                loading.close()
              })
            }
          }
        }else{
          this.$message.error(res.errorMsg)
        }
      })
      this.getAuditStatus(row)

    },
    // 保存
    save(){
      this.$refs.form.validate(valid=>{
        if(valid){
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)',
          });
          if(this.form.priceType === 1){
            this.form.price2 = ''
          }
          if(this.dialogTitle === 'add'){
            this.$axios.fetchPost(api.mall.mallLiveGoods,this.form).then(res=>{
              if(res.code === 200 && res.data){
                this.$notify({
                  type: "success",
                  title: '新增操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message.success('新增成功')
                this.closeDialog()
                this.$refs.mallgoodsTemplate.operationSuccess()
              }else{
                this.$notify({
                  type: "error",
                  title: '新增操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message.error( res.errorMsg||'保存失败')
              }
            }).finally(()=>{
              loading.close()
            })
          }
          if(this.dialogTitle === 'edit'){
            this.$axios.fetchPut(api.mall.mallLiveGoods,this.form).then(res=>{
              if(res.code === 200 && res.data){
                this.$notify({
                  type: "success",
                  title: '编辑操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message.success('编辑成功')
                this.closeDialog()
                this.$refs.mallgoodsTemplate.operationSuccess()
              }else{
                this.$notify({
                  type: "error",
                  title: '编辑操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message.error( res.errorMsg||'保存失败')
              }
            }).finally(()=>{
              loading.close()
            })
          }
        }else{
          return false
        }
      })
    },
    // 关闭
    closeDialog(){
      this.addShow = false
      this.form={
        url:'pages/details/details',//商品详情页的小程序路径
        coverImg:'',
        coverImgUrl:'',
        goodsImgUrl:'',
        barCode:'',
        name:'',
        priceType:1,
        price:'',//原价
        price2:'',//右区间价 || 折扣价
        remarks:'',
        relateType:this.$utils.getSysUser().storeId?20:10,//10 商户 20门店
      }
      this.$refs.form.resetFields()
    },
    // 删除
    deleteInfo(row){
      this.$confirm('删除本条数据, 是否确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.fetchDelete(api.mall.mallLiveGoods+'?id='+row.goodsId).then(res=>{
          if(res.code === 200){
            this.$notify({
              type: "success",
              title: '删除操作',
              message: '成功',
              showClose: false,
            });
            // this.$message.success('删除成功')
            this.$refs.mallgoodsTemplate.operationSuccess()
          }else{
            this.$notify({
              type: "error",
              title: '删除操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error(res.errorMsg || '删除失败')
          }
        })
      }).catch(() => {});

    },
  }
};
</script>
<style scoped>
>>> .el-form-item__content, .el-form-item__label{
  line-height: 30px;
}
/*上传样式*/
.file-upload{
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px dashed #C0C4CC;
  border-radius: 5px;
  color: #C0C4CC;
  background-size: 100% 100%;
  position: relative;
  margin-right: 10px;
  margin-bottom: 20px;
  font-size: 40px;
}
.file-upload .img-item{
  border:none;
}
.file-upload .img-item .icon-delete {
  font-size: 20px;
  position: absolute;
  right: 0px;
  top: 0px;
  cursor: pointer;
  color:red;
}
.file-upload .img-item .image-box {
  width: 78px;
  height: 78px;
  border-radius: 5px;
  background-size:100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/system/applet/live/liveGoods.vue